import { useEffect } from "react";

export default function useSeo({ title, description, canonical, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
      m.setAttribute("content", description);
    }

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
      link.setAttribute("href", canonical);
    }

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "page");
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => { if (script) script.remove(); };
  }, [title, description, canonical, jsonLd]);
}
